var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadUnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.2,
    height: 17.2,
    viewBox: "0 0 17.2 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #d3d3d3;\r\n        stroke-linecap: round;\r\n        stroke-width: 1.2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711",
    transform: "translate(-6418.9 4700.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    className: "cls-1",
    d: "M8.7,10.3l5.008,5,4.992-5",
    transform: "translate(6413.8 -4701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    className: "cls-2",
    d: "M11,19V5",
    transform: "translate(6416.5 -4705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    className: "cls-2",
    d: "M5,18H21",
    transform: "translate(6414.5 -4702)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadUnactive);
export default __webpack_public_path__ + "static/media/downloadUnactive.59af5936eb06f4e3293dad04f1e4d4ee.svg";
export { ForwardRef as ReactComponent };